import { useState } from 'react';
import { formatCurrency } from '../utils/format';
import './Withdrawals.css';

interface WithdrawalsProps {
  profile: any;
}

export function Withdrawals({ profile }: WithdrawalsProps) {
  const [amount, setAmount] = useState('');
  const [method, setMethod] = useState('USDT TRC-20');
  const [wallet, setWallet] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleWithdraw = async () => {
    if (!amount || parseFloat(amount) < 10) {
      alert('Минимальная сумма для вывода: 10 USDT');
      return;
    }

    if (parseFloat(amount) > profile?.balance) {
      alert('Недостаточно средств');
      return;
    }

    if (!wallet) {
      alert('Укажите адрес кошелька');
      return;
    }

    setIsLoading(true);
    
    // Имитация отправки запроса
    setTimeout(() => {
      setIsLoading(false);
      setSuccess(true);
      setAmount('');
      setWallet('');
      
      setTimeout(() => setSuccess(false), 3000);
      
      // Здесь будет реальный API запрос
      // await fetch('/api/partner/withdrawal', { method: 'POST', body: ... });
    }, 1500);
  };

  const quickAmounts = [10, 50, 100, 500];

  return (
    <div className="withdrawals">
      <div className="balance-card">
        <div className="balance-icon">💰</div>
        <div className="balance-info">
          <p className="balance-label">Доступно для вывода</p>
          <h2 className="balance-amount">{formatCurrency(profile?.balance || 0)}</h2>
        </div>
      </div>

      <div className="withdrawal-form">
        <h3 className="form-title">Заявка на вывод</h3>

        <div className="form-group">
          <label className="form-label">Метод вывода</label>
          <select 
            className="form-select"
            value={method}
            onChange={(e) => setMethod(e.target.value)}
          >
            <option value="USDT TRC-20">USDT TRC-20</option>
            <option value="USDT ERC-20">USDT ERC-20</option>
            <option value="BTC">Bitcoin (BTC)</option>
            <option value="ETH">Ethereum (ETH)</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Сумма (USDT)</label>
          <div className="amount-input-wrapper">
            <input
              type="number"
              className="form-input"
              placeholder="10.00"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              min="10"
              step="0.01"
            />
            <span className="input-currency">USDT</span>
          </div>
          <p className="form-hint">Минимальная сумма: 10 USDT</p>
        </div>

        <div className="quick-amounts">
          {quickAmounts.map((value) => (
            <button
              key={value}
              className="quick-amount-btn"
              onClick={() => setAmount(value.toString())}
              disabled={value > (profile?.balance || 0)}
            >
              {value} USDT
            </button>
          ))}
          <button
            className="quick-amount-btn"
            onClick={() => setAmount(profile?.balance?.toString() || '0')}
          >
            Все
          </button>
        </div>

        <div className="form-group">
          <label className="form-label">Адрес кошелька</label>
          <input
            type="text"
            className="form-input"
            placeholder="Введите адрес кошелька"
            value={wallet}
            onChange={(e) => setWallet(e.target.value)}
          />
        </div>

        <button
          className="withdraw-btn"
          onClick={handleWithdraw}
          disabled={isLoading || !amount || !wallet}
        >
          {isLoading ? (
            <>
              <span className="btn-loader"></span>
              Обработка...
            </>
          ) : success ? (
            <>✓ Заявка создана</>
          ) : (
            <>Создать заявку на вывод</>
          )}
        </button>

        <div className="form-info">
          <p>⏱ Обработка заявок: до 24 часов</p>
          <p>💳 Комиссия сети оплачивается отдельно</p>
        </div>
      </div>

      <div className="withdrawal-history">
        <h3 className="section-title">История выводов</h3>
        <div className="history-list">
          {/* Демо данные */}
          <div className="history-item">
            <div className="history-icon pending">⏳</div>
            <div className="history-info">
              <p className="history-method">USDT TRC-20</p>
              <p className="history-date">24 января, 15:30</p>
            </div>
            <div className="history-amount">
              <p className="amount">-{formatCurrency(150)}</p>
              <p className="status pending">В обработке</p>
            </div>
          </div>

          <div className="history-item">
            <div className="history-icon completed">✓</div>
            <div className="history-info">
              <p className="history-method">USDT TRC-20</p>
              <p className="history-date">20 января, 10:15</p>
            </div>
            <div className="history-amount">
              <p className="amount">-{formatCurrency(500)}</p>
              <p className="status completed">Выполнено</p>
            </div>
          </div>

          <div className="history-item">
            <div className="history-icon completed">✓</div>
            <div className="history-info">
              <p className="history-method">BTC</p>
              <p className="history-date">15 января, 18:45</p>
            </div>
            <div className="history-amount">
              <p className="amount">-{formatCurrency(300)}</p>
              <p className="status completed">Выполнено</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
